/* eslint-disable react/no-array-index-key */
/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable max-len */
/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/state-in-constructor */
import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import axios from 'axios';
import ls from 'local-storage';
import _ from 'lodash';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import LinearProgress from '@material-ui/core/LinearProgress';
import VisibilitySensor from 'react-visibility-sensor';
import OlsBottomNav from '../../container/OlsBottomNav/OlsBottomNav';
import OlsSearch from '../../container/OlsSearch/OlsSearch';
import OlsOrderRow from '../../component/OlsOrderRow/OlsOrderRow';

let isMounted = false;

const useStyles = (theme) => ({
  appBarWrapper: {
    backgroundColor: 'white',
  },
  appBar: {
    backgroundColor: theme.palette.primary.main,
    maxWidth: theme.palette.width.maxWidth,
    width: '100%',
    position: 'fixed',
    top: 0,
    left: 'auto',
    right: 'auto',
    paddingRight: '0px !important',
  },
  appBarTitle: {
    position: 'relative',
    display: 'block',
    fontWeight: 'bold',
    marginLeft: 0,
    width: '100%',
  },
  appToolbar: {
    height: 62,
    minHeight: 62,
    maxHeight: 62,
  },
  appBarRightIcon: {
    display: 'flex',
  },
  topWrapper: {
    backgroundColor: 'white',
    height: '50px',
    maxWidth: theme.palette.width.maxWidth,
    width: '100%',
    position: 'fixed',
    top: 62,
    left: 'auto',
    right: 'auto',
    zIndex: '1099',
  },
  content: {
    marginTop: 54,
    padding: 4,
    display: 'block',
    minHeight: 1000,
    '&::after': {
      content: '""',
      clear: 'both',
      display: 'table',
    },
  },
});

// const orders = [
//   {
//     order_uxid: '1234',
//     order_version: 'V!',
//     order_account_uxid: '4324213',
//     order_from_type: '2432143',
//     order_from_uxid: '2432143214',
//     order_number: '243245325',
//     order_name: 'wianto',
//     order_courier_code: 'jnt',
//     order_courier_name: 'JNE',
//     order_courier_service: 'Reguler',
//     order_courier_description: ' ',
//     order_store_name: 'Laris Manis',
//     order_store_province_id: '1',
//     order_store_province_name: '2',
//     order_store_city_id: '3',
//     order_store_city_name: '4',
//     order_store_city_type: '5',
//     order_store_subdistrict_id: '6',
//     order_store_subdistrict_name: '7',
//     order_shipping_realname: 'Wianto',
//     order_shipping_code: 'JT1726296122',
//     order_shipping_phone: '0812345678',
//     order_shipping_company: 'Company',
//     order_shipping_email: 'wianto@gmail.com',
//     order_shipping_address1: 'Desa Gentawangi RT.01/05',
//     order_shipping_address2: 'Jatilawang',
//     order_shipping_address3: 'Banyumas',
//     order_shipping_address4: '53174',
//     order_shipping_address5: ' ',
//     order_shipping_location_id: '1',
//     order_shipping_province_id: '2',
//     order_shipping_province_name: '3',
//     order_shipping_city_id: '4',
//     order_shipping_city_name: '5',
//     order_shipping_city_type: '6',
//     order_shipping_subdistrict_id: '7',
//     order_shipping_subdistrict_name: '8',
//     order_shipping_note: 'OK',
//     order_shipping_detail: 'OK',
//     order_shipping_cost: 2000,
//     order_weight: 1000,
//     order_value: 4750,
//     order_tax_percent: 10,
//     order_tax_value: 475,
//     order_discount_type: 'PERCENTAGE',
//     order_discount_value: 0,
//     order_discount_price: 0,
//     order_total: 7700,
//     order_profit: 0,
//     order_uxcode: 123,
//     order_cash_pay: 7823,
//     order_cash_change: 123,
//     order_note: '',
//     order_step: 'CHECKOUT',
//     order_payment_status: 'WAIT',
//     order_expired_status: '0',
//     order_mutasi_uxid: '214231',
//     order_status: 'REJECTED',
//     order_timestamp: 1588776330,
//     order_date: '2020/05/05',
//     order_expired_datetime: '2020/05/06',
//   },
// ];

// const items = [
//   {
//     item_uxid: '1234',
//     item_account_uxid: '',
//     item_from_type: '',
//     item_from_uxid: '',
//     item_order_uxid: '',
//     item_order_version: '',
//     item_parent_uxid: '',
//     item_group: 'TRS',
//     item_tree: 'TRS',
//     item_product_type: 'wianto',
//     item_product_uxid: 'wianto',
//     item_product_name: 'wianto',
//     item_product_code: 'wianto',
//     item_product_unit: 'wianto',
//     item_product_weight: 'wianto',
//     item_product_base_price: 'wianto',
//     item_product_sale_price: 'wianto',
//     item_product_discount_type: 'wianto',
//     item_product_discount_value: 'wianto',
//     item_amount: 'wianto',
//     item_weight: 'wianto',
//     item_base_value: 'wianto',
//     item_sale_value: 'wianto',
//     item_discount_type: 'wianto',
//     item_discount_value: 'wianto',
//     item_discount_price_unit: 'wianto',
//     item_discount_price_total: 'wianto',
//     item_base_total: 'wianto',
//     item_sale_total: 'wianto',
//     item_profit: 'wianto',
//     item_total: 'wianto',
//     item_note: '',
//     item_status: 'CHECKOUT',
//     item_timestamp: 0,
//   },
// ];

const { pathname } = window.location;
const arrPath = pathname.split('/');
const username = (arrPath && arrPath.length >= 3) ? arrPath[3] : '';

class Order extends Component {
  constructor(props) {
    super(props);
    this.state = {
      usr_info: ls.get('usr_info') || {},
      order_list: [],
      loading: false,
      more: false,
      search_text: '',
    };
  }

  componentDidMount() {
    isMounted = true;
    this.usrInfoGet();
    this.setState({
      order_list: ls.get(`${username}_orders`) || [],
    });
    const formdata = new FormData();
    formdata.append('u', username);
    formdata.append('last_count', 0);
    axios.post('https://eqiozmart.com/olsapi/olshop/order_list/', formdata).then((response) => {
      if (isMounted) {
        if (_.isArray(response.data.orders)) {
          if (_.size(response.data.orders) > 0) {
            this.setState({
              more: true,
            });
          } else {
            this.setState({
              more: false,
            });
          }
          this.setState({
            order_list: response.data.orders,
          });
          ls.set(`${username}_orders`, response.data.orders);
        }
      }
    });
    window.scrollTo(0, 0);
  }

  componentWillUnmount() {
    isMounted = false;
  }

  usrInfoGet = () => {
    if (isMounted) {
      this.setState({ loading: true });
      axios.post('https://eqiozmart.com/olsapi/acc/app_usr_info/').then((response) => {
        if (isMounted) {
          this.setState({ loading: false });
          if (_.isObject(response.data.usr_info)) {
            this.setState({ usr_info: response.data.usr_info });
            ls.set('usr_info', this.state.usr_info);
          } else {
            this.setState({ usr_info: false });
            ls.set('usr_info', this.state.usr_info);
            this.props.history.push('/login');
          }
        }
      });
    }
  }

  orderViewOpen = (data) => {
    if (isMounted) {
      this.props.history.push(`/orderview/${data.order_uxid}`);
    }
  }

  handleSearchOnChange = (value) => {
    if (isMounted) {
      this.setState({
        search_text: value,
      });
      this.setState({ loading: true });
      const formdata = new FormData();
      formdata.append('u', username);
      formdata.append('search', value);
      formdata.append('last_count', 0);
      axios.post('https://eqiozmart.com/olsapi/olshop/order_search/', formdata).then((response) => {
        if (isMounted) {
          if (_.isArray(response.data.orders)) {
            if (_.size(response.data.orders) > 0) {
              this.setState({
                more: true,
              });
            } else {
              this.setState({
                more: false,
              });
            }
            this.setState({
              order_list: response.data.orders,
            });
          }
        }
      });
    }
  }

  handleSearchOnSubmit = (value) => {
    if (isMounted) {
      this.setState({
        search_text: value,
      });
      this.setState({ loading: true });
      const formdata = new FormData();
      formdata.append('u', username);
      formdata.append('search', value);
      formdata.append('last_count', 0);
      axios.post('https://eqiozmart.com/olsapi/olshop/order_search/', formdata).then((response) => {
        if (isMounted) {
          if (_.isArray(response.data.orders)) {
            if (_.size(response.data.orders) > 0) {
              this.setState({
                more: true,
              });
            } else {
              this.setState({
                more: false,
              });
            }
            this.setState({
              order_list: response.data.orders,
            });
          }
        }
      });
    }
  }

  doListMore = () => {
    if (isMounted) {
      const lastCount = _.size(this.state.order_list);
      const formdata = new FormData();
      formdata.append('u', username);
      formdata.append('last_count', lastCount);
      axios.post('https://eqiozmart.com/olsapi/olshop/order_list/', formdata).then((response) => {
        if (isMounted) {
          if (_.isArray(response.data.orders)) {
            if (_.size(response.data.orders) > 0) {
              this.setState({
                more: true,
              });
              const orderList = _.unionBy(this.state.order_list, response.data.orders, 'order_uxid');
              this.setState({
                order_list: orderList,
              });
            } else {
              this.setState({
                more: false,
              });
            }
          }
        }
      });
    }
  }

  doSearchMore = () => {
    if (isMounted) {
      const lastCount = _.size(this.state.order_list);
      const formdata = new FormData();
      formdata.append('u', username);
      formdata.append('search', this.state.search_text);
      formdata.append('last_count', lastCount);
      axios.post('https://eqiozmart.com/olsapi/olshop/order_search/', formdata).then((response) => {
        if (isMounted) {
          if (_.isArray(response.data.orders)) {
            if (_.size(response.data.orders) > 0) {
              this.setState({
                more: true,
              });
              const orderList = _.unionBy(this.state.order_list, response.data.orders, 'order_uxid');
              this.setState({
                order_list: orderList,
              });
            } else {
              this.setState({
                more: false,
              });
            }
          }
        }
      });
    }
  }

  handleLoadMore = (isMore) => {
    if (isMore) {
      this.setState({
        more: false,
      });
      if (_.isEmpty(this.state.search_text)) {
        this.doListMore();
      } else {
        this.doSearchMore();
      }
    }
  }

  render() {
    const { classes } = this.props;
    return (
      <div>
        <div className={classes.appBarWrapper}>
          <AppBar className={classes.appBar}>
            <Toolbar className={classes.appToolbar}>
              <Typography className={classes.appBarTitle} variant="h6" noWrap>
                Order
              </Typography>
            </Toolbar>
            <div style={{ marginBottom: -5, height: 5 }}>
              <LinearProgress style={this.state.loading ? {} : { display: 'none' }} />
            </div>
          </AppBar>
        </div>
        <div style={(!_.isString(this.state.usr_info.usr_realname)) ? { display: 'none' } : {}}>
          <div style={{ paddingBottom: 56 }}>
            <div className={classes.topWrapper}>
              <OlsSearch onChange={this.handleSearchOnChange} onSubmit={this.handleSearchOnSubmit} />
            </div>
            <div className={classes.content}>
              {
                this.state.order_list.map((order, index) => <OlsOrderRow key={index} data={order} onOpen={(data) => this.orderViewOpen(data)} />)
              }
            </div>
            <VisibilitySensor onChange={this.handleLoadMore}>
              <div style={{ height: 5 }}>
                <LinearProgress style={this.state.more ? {} : { display: 'none' }} />
              </div>
            </VisibilitySensor>
          </div>
        </div>
        <OlsBottomNav value="order" />
      </div>
    );
  }
}

export default withStyles(useStyles)(Order);
